import { BaseDataResult } from './base-data-result.model';

export class DataResult extends BaseDataResult {
    private data: any;

    constructor(ok: boolean, status: number, statusText: string, data: any) {
        super(ok, status, statusText);
        this.data = data;
    }

    get Data(): any {
        return this.data;
    }
}
